import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { forkJoin } from 'rxjs';
import { isUndefined } from 'util';

import { LearnCertClass } from '../../model/learn-cert/learn-cert-class';
import { LearnCertDisableConfig } from '../../model/learn-cert/learn-cert-disable-config/learn-cert-disable-config';
import { LearnCertEntry } from '../../model/learn-cert/learn-cert-entry';
import { NecToast } from '../../service/toast/toast.service';
import { DataOperationUtil } from '../../service/util/data-operation.util';
import { DropDownMenuItem } from '../dropdown-menu/dropdown-menu-item';
import { LearnCertChosenResult } from './learncert-chosen-result';
import { LearnCertMenuItem } from './learncert-menu-item';
import { NecLearnCertService } from './learncert.service';

@Component({
  selector: 'nec-learncert',
  templateUrl: './learncert.component.html',
  styleUrls: ['./learncert.component.scss']
})
export class NecLearnCertComponent implements OnInit {

  /**
   * ç¨ä½setå·²éæ°æ®
   */
  @Input() chosenInfo?: LearnCertChosenResult;

  @Input() isOptional = true;

  /**
   * å­¦ä¹ å­æ®åå®¹åçæ¹åæ¶é´
   */
  @Output() learncertChosenChangeEvent: EventEmitter<LearnCertChosenResult> = new EventEmitter();

  /**
   * ä¸æèåå®ä½
   */
  @Input() dropDownMenuPosition = 'absolute'; // absolute || fixed

  /**
   * å­¦ä¹ å­æ®å¤§ç±»éæ©ç»æ
   */
  chosenLearncertMenuItem: LearnCertMenuItem[] = [];

  /**
   * å­¦ä¹ å­æ®å°ç±»éæ©ç»æ
   */
  chosenChildTypeMenuItem: DropDownMenuItem[] = [];

  /**
   * æ¯ä¸è¡è¾å¥çæ°æ®
   */
  chosenLearncertvalue: string[] = [];

  /**
   * å­é¡¹id vs å­æ®å¤§ç±»id
   */
  disableSet: Set<number> = new Set();

  /**
   * æ¯ä¸è¡çæ°æ®
   */
  learncertItem: LearnCertMenuItem[] = [];

  /**
   * ææè¡çæ°æ®
   */
  learncertItems: LearnCertMenuItem[][] = [];

  hasLearncert: boolean;

  constructor(private learnCertService: NecLearnCertService, private toast: NecToast) {
  }

  ngOnInit() {
    setTimeout(() => {
      forkJoin(this.learnCertService.getLearnCertDict(),
        this.learnCertService.getLearnCertDisableConfigDict())
        .subscribe((result: [LearnCertClass[], LearnCertDisableConfig]) => {
          let learnCertClasses = result[0];
          let disableConfig = result[1];
          this.learnCertService.resetDisabled(learnCertClasses, disableConfig);
          this.learncertItem = this.learnCertService.packageLearnCertMenu(learnCertClasses);
          if (!isUndefined(this.chosenInfo)) {
            this.allowLearncert();
            this.hasLearncert = true;
            for (let i = 0; i < this.chosenInfo.entries.length; i++) {
              this.addNewLearnCertMenuItem(false, this.chosenInfo.entries[i]);
            }
          }
        });
    });
  }

  learncertTypeChosenItemChange(learncertTypeItem: LearnCertMenuItem, idx: number) {
    /**
     * å·²ç»éè¿å­¦ä¹ å­æ® å°åç±»çæåµ åæ¢å­¦ä¹ å­æ®å¤§ç±» å°å°ç±»çå·²éé¡¹ ä»å·²ééåä¸­å é¤
     */
    if (this.chosenChildTypeMenuItem[idx]) {
      this.disableSet.delete(this.chosenChildTypeMenuItem[idx].id);
    }
    this.chosenLearncertMenuItem[idx].childrenMenuItem.forEach(item => {
      item.chosen = false;
    });
    this.chosenLearncertMenuItem[idx] = learncertTypeItem;
    this.chosenChildTypeMenuItem[idx] = null; // this.chosenLearncertMenuItem[idx].childrenMenuItem[0];
    this.learncertDataChange(this.hasLearncert);
  }

  learncertChildTypeChoseItemChange(dropDownMenuItem: DropDownMenuItem, idx: number) {
    if (this.chosenChildTypeMenuItem[idx]) {
      // å°å­¦ä¹ å­æ®å°ç±»éé¡¹ åä¸ä¸ªå·²éé¡¹çä»å·²ééåä¸­å é¤
      this.disableSet.delete(this.chosenChildTypeMenuItem[idx].id);
    }
    this.disableSet.add(dropDownMenuItem.id);
    this.chosenChildTypeMenuItem[idx] = dropDownMenuItem;
    this.learncertDataChange(this.hasLearncert);
  }

  deleteLearncertItem(idx: number) {
    this.learncertItems.splice(idx, 1);
    this.chosenLearncertMenuItem.splice(idx, 1);
    // å°å°ç±»çå·²éé¡¹ä» å·²ééåä¸­å é¤
    if (this.chosenChildTypeMenuItem[idx]) {
      this.disableSet.delete(this.chosenChildTypeMenuItem[idx].id);
    }
    this.chosenChildTypeMenuItem.splice(idx, 1);
    this.chosenLearncertvalue.splice(idx, 1);
    this.learncertDataChange(this.hasLearncert);
  }

  // todo éè¦ç²¾ç®
  addNewLearnCertMenuItem(isNew: boolean, entryItem?: LearnCertEntry) {
    let item = [];
    this.learncertItem.forEach(data => {
      item.push(data.copy());
    });
    this.learncertItems.push(item);
    let idx = this.learncertItems.length - 1;
    if (isNew) {
      this.chosenLearncertvalue[idx] = '';
      this.chosenLearncertMenuItem[idx] = item.find(menuItem => menuItem.show);
      if (this.chosenLearncertMenuItem[idx]) {
        this.chosenLearncertMenuItem[idx].chosen = true;
      }
      this.chosenChildTypeMenuItem[idx] = null; // learncertItem[0].childrenMenuItem[0];
    } else {
      if (idx < this.chosenInfo.entries.length) {
        let tempItem = item.find(data => data.id === entryItem.classId);
        if (tempItem) {
          this.chosenLearncertMenuItem[idx] = DataOperationUtil.deepCopy(tempItem);
          this.chosenLearncertMenuItem[idx].chosen = true;
          this.chosenLearncertvalue[idx] = this.chosenInfo.entries[idx].number.toString();
          let childItem = this.chosenLearncertMenuItem[idx].childrenMenuItem;
          if (childItem) {
            let tempChildItem = childItem.find(data => data.id === entryItem.typeId);
            this.chosenChildTypeMenuItem[idx] = tempChildItem;
            this.chosenChildTypeMenuItem[idx].chosen = true;
            this.disableSet.add(tempChildItem.id);
          }
        } else {
          this.learncertItem.pop();
        }
      }
    }
    this.learncertDataChange(true);
  }

  /**
   * ç¦ç¨å­¦å
   */
  forbidLearncert() {
    this.learncertItems = [];
    this.disableSet.clear();
    this.hasLearncert = false;
    this.learncertDataChange(false);
  }

  /**
   * æ·»å å­¦å
   */
  allowLearncert() {
    if (!this.chosenInfo && this.learncertItems.length === 0) {
      // æå¯ä»¥éæ©çå­¦ä¹ å­æ®æè½æäºå­¦å
      let showItem = this.learncertItem.find(item => item.show);
      this.hasLearncert = !!showItem;
      if (!this.hasLearncert) {
        this.toast.warning('å­¦ä¹ å­æ®è¢«ç¦ç¨ï¼ä¸å¯ä½¿ç¨');
      } else {
        this.addNewLearnCertMenuItem(true);
      }
    } else {
      this.hasLearncert = true;
    }
  }

  /**
   * åå°éæ©ç»æ
   * ç±chosenLearncertMenuItemãchosenChildTypeMenuItemãchosenLearncertvalueç»è£èæ
   */
  learncertDataChange(hasLearnCert: boolean) {
    for (let i = 0; i < this.chosenLearncertvalue.length; i++) {
      let value = Number(this.chosenLearncertvalue[i]);
      this.chosenLearncertvalue[i] = this.learnCertService.checkLearnCertValue(value);
    }
    let learnCertChosen = this.learnCertService.packageLearnCertChosenResult(hasLearnCert,
      this.chosenLearncertMenuItem, this.chosenChildTypeMenuItem, this.chosenLearncertvalue);
    this.learncertChosenChangeEvent.emit(learnCertChosen);
  }

}
